import * as React from 'react'
import { styled,SxProps } from '@mui/material/styles'
import FormControlLabel, { FormControlLabelProps } from '@mui/material/FormControlLabel'
import Switch, { SwitchProps } from '@mui/material/Switch'
import { UseControllerProps, Control, useController } from 'react-hook-form'

export interface ISwitchInputProps extends Omit<UseControllerProps, 'control'> {
    onBeginChange?(event: React.ChangeEvent<HTMLInputElement>): any,
    onChange?(event: React.ChangeEvent<HTMLInputElement>): any,
    onBlur?(event: React.FocusEvent<any>): any,
    control: Control<any, object>
    step?: number,
    id: any,
    label?: string,
    name: string,
    sx?:SxProps,
    disabled?:boolean;
    labelPlacement?: 'top' | 'start' | 'bottom' | 'end'
}

styled

const IOSSwitch = styled((props: SwitchProps) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 5,
        transitionDuration: '300ms',
        '&.Mui-checked': {
            transform: 'translateX(16px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                border: `4px solid ${theme.palette.primary.dark}`,
                backgroundColor: theme.palette.common.white,
                opacity: 1,
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.5,
            },
        },
        '&.Mui-focusVisible .MuiSwitch-thumb': {
            color: theme.palette.primary.main,
            border: '6px solid #fff',
        },
        '&.Mui-disabled .MuiSwitch-thumb': {
            color:
                theme.palette.mode === 'light'
                    ? theme.palette.grey[100]
                    : theme.palette.grey[600],
        },
        '&.Mui-disabled + .MuiSwitch-track': {
            opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
        },
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        backgroundColor: theme.palette.primary.dark,
        width: 16,
        height: 16,
    },
    '& .MuiSwitch-track': {
        border: `4px solid ${theme.palette.grey[500]}`,
        borderRadius: 26 / 2,
        backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 500,
        }),
    },
}));

export default function SwitchInput({ id, name, label, control,disabled, labelPlacement = 'end', sx, onChange, onBeginChange, ...other }: ISwitchInputProps) {

    const { field, fieldState } = useController({ control, name })

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        let valueToSet = field.value instanceof Boolean ? event.target.checked : +event.target.checked
        onBeginChange && onBeginChange(event)
        field.onChange(valueToSet)
        onChange && onChange(event)
    }

    return (
        <FormControlLabel
            control={<IOSSwitch id={id} sx={{ m: 1 }} inputRef={field.ref} checked={!!field.value} onChange={handleChange} />}
            label={label || ''}
            labelPlacement={labelPlacement}
            sx={{m:0,...sx}}
            disabled={disabled}
            {...other}
        />
    );
}
